import { useEffect, useState } from "react";
import DatePickerDefault, { registerLocale } from "react-datepicker";
import hu from "date-fns/locale/hu";

import React from "react";
import { addYears, subDays } from "date-fns";
import { getCurrentWeek, getMonday } from "../../legacyUtils";
import CalendarIcon from "./CalendarIcon";
import i18n from "i18next";

registerLocale("hu", hu);

interface Props {
    monday: Date;
    setWeeks: React.Dispatch<React.SetStateAction<number[]>>;
}

const DatePicker = ({ monday, setWeeks }: Props) => {
    const [startDate, setStartDate] = useState(new Date());

    // Change picker date when changing weeks
    useEffect(() => {
        setStartDate(monday);
    }, [monday]);

    const handleDatePick = (date: Date) => {
        setStartDate(date);
        const week = getCurrentWeek(date);
        setWeeks([week, week === 52 ? 1 : week + 1]);
    };

    return (
        <DatePickerDefault
            customInput={<CalendarIcon />}
            selected={startDate}
            onChange={handleDatePick}
            popperPlacement="top"
            showWeekNumbers
            disabledKeyboardNavigation
            locale={i18n.language === "hu" ? "hu" : "en"}
            minDate={new Date()}
            maxDate={subDays(getMonday(addYears(new Date(), 1)), 1)}
        />
    );
};

export default DatePicker;
